<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :get-data-func="getReservationGroupList"
      :headers="headers"
      @click:row="goDetails($event.item)"
      clickable
      init-sort-by="name"
      ref="reservationGroupList"
      title-text="预约分组列表"
      v-model="selected"
      search-text="搜索分组名称"
    >
    </l-data-table>
  </l-layout>
</template>

<script>
  // import {time} from '../../../ladmin/utils'
  // import LActionCard from '../../../components/LActionCard'
  import defaults from '../../../consts'
  export default {
    name: 'reservationGroupList',
    // components: {LActionCard},
    data: () => ({
      selected: [],
      floatingButton: false,
      moreActions: [
        {
          event: 'delete',
          label: '批量删除',
          icon: '$vuetify.icons.deleteAll'
        },
      ],
      headers: defaults.userAdmin.GROUP_HEADERS,
    }),
    methods: {
      async getReservationGroupList ({pagination, sortStack, filterItems, search}) {
        let res = await this.$store.dispatch('userAdmin/getOrgListByName', {
          pagination,
          name: search,
          id: '',
          type: 'appt'
        })
        console.log(res)
        if (res.data.status === 1) {
          return {items: res.data.data.content, amount: res.data.data.totalElements}
        }
        else {
          this.$L.alert('查询分组信息失败，原因:' + res.data.msg)
        }
      },
      refresh () {
        if (this.$refs.reservationGroupList) {
          this.$refs.reservationGroupList.refresh()
        }
      },
      async deleteOrg (org) {
        // console.log(user)
        if (!org) return
        let {res, close} = await this.$L.confirm({
          title: '确认删除该单位？',
          text: org.name || `N/A`,
        })
        if (res) {
          try {
            await this.$store.dispatch('userAdmin/deleteGroups', [org])
            this.refresh()
            this.$L.alert('success', {message: '删除成功'})
          }
          catch (e) {
            this.$L.alert('error', {message: e.message})
          }
        }
        close()
      },
      goDetails (item, force) {
        let selectionString = document.getSelection().toString()
        if (!selectionString || force) {
          this.$router.push({
            name: 'reservationGroupDetail',
            params: {name: item.name},
            query: {id: item.id}
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
